(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kc-cart-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kc-cart-offer-slider')) {
    customElements.define('kc-cart-offer-slider', class extends HTMLElement {
      connectedCallback() {
        this.index = this.index || 0;
        this.drawer = this.closest('cart-drawer');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        this.querySelector('.kc-cart-offer-slider__text').setAttribute('aria-live', 'off');
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-step]');
          if (!button) return;
          this.advance(Number(button.dataset.step), true);
          this.start();
        }, options);
        this.addEventListener('pointerenter', () => this.stop(), options);
        this.addEventListener('pointerleave', () => this.start(), options);
        this.addEventListener('focusin', () => this.stop(), options);
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) this.start();
        }, options);
        document.addEventListener('visibilitychange', () => this.start(), options);
        this.motion.addEventListener('change', () => this.start(), options);
        this.observer = new MutationObserver(() => this.start());
        if (this.drawer) this.observer.observe(this.drawer, {attributes: true, attributeFilter: ['class']});
        this.start();
      }
      disconnectedCallback() {
        this.stop();
        this.observer?.disconnect();
        this.controller?.abort();
      }
      advance(step, manual = false) {
        const slides = [...this.querySelectorAll('[data-slide]')];
        if (!slides.length) return;
        this.querySelector('.kc-cart-offer-slider__text').setAttribute('aria-live', manual ? 'polite' : 'off');
        this.index = (this.index + step + slides.length) % slides.length;
        slides.forEach((slide, index) => { slide.hidden = index !== this.index; });
      }
      stop() {
        clearTimeout(this.timer);
      }
      start() {
        this.stop();
        if (!this.isConnected || !this.drawer?.classList.contains('active') || document.hidden || this.motion.matches || this.matches(':hover') || this.contains(document.activeElement)) return;
        this.timer = setTimeout(() => {
          this.advance(1);
          this.start();
        }, 4000);
      }
    });
  }
  if (!customElements.get('kc-cart-coupons')) {
    customElements.define('kc-cart-coupons', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.querySelector('form').addEventListener('submit', event => {
          event.preventDefault();
          const code = this.querySelector('input').value.trim();
          if (code) this.apply(code);
        });
        this.addEventListener('click', event => {
          const offer = event.target.closest('[data-apply-code]');
          if (offer) this.apply(offer.dataset.applyCode);
          if (event.target.closest('[data-remove-code]')) this.apply('');
        });
      }
      async apply(code) {
        if (this.getAttribute('aria-busy') === 'true') return;
        const drawer = this.closest('cart-drawer');
        const labels = {...this.dataset};
        const expanded = this.querySelector('.kc-cart-offer-details').open;
        const status = this.querySelector('.kc-cart-code-status');
        const checkout = drawer.querySelector('#CartDrawer-Checkout');
        status.hidden = false;
        status.dataset.error = 'false';
        status.textContent = labels.loading;
        this.setAttribute('aria-busy', 'true');
        if (checkout) checkout.disabled = true;
        try {
          const response = await fetch(labels.updateUrl, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({discount: code, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname})
          });
          if (!response.ok) throw new Error('cart update failed');
          const data = await response.json();
          if (!data.sections?.['cart-drawer'] || !data.sections?.['cart-icon-bubble']) {
            const sectionsResponse = await fetch(labels.cartUrl + '?sections=cart-drawer,cart-icon-bubble');
            if (!sectionsResponse.ok) throw new Error('cart refresh failed');
            data.sections = await sectionsResponse.json();
          }
          if (!data.sections?.['cart-drawer'] || !data.sections?.['cart-icon-bubble']) throw new Error('cart sections missing');
          const applications = [
            ...(data.cart_level_discount_applications || []),
            ...(data.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(a => a.discount_application))
          ];
          const applied = !code || (data.discount_codes || []).some(d => d.code.toUpperCase() === code.toUpperCase() && d.applicable)
            || applications.some(d => d && d.title.toUpperCase() === code.toUpperCase());
          drawer.renderContents(data, true);
          const current = drawer.querySelector('kc-cart-coupons');
          current.querySelector('.kc-cart-offer-details').open = expanded;
          const input = current.querySelector('input');
          input.value = code;
          const message = current.querySelector('.kc-cart-code-status');
          message.hidden = false;
          message.dataset.error = String(!applied);
          message.textContent = !code ? labels.removed : applied ? labels.success.replace('[code]', code) : labels.invalid;
          if (typeof trapFocus === 'function') trapFocus(drawer.querySelector('.drawer__inner'), input);
          input.focus({preventScroll: true});
        } catch {
          const current = drawer.querySelector('kc-cart-coupons') || this;
          const message = current.querySelector('.kc-cart-code-status');
          message.hidden = false;
          message.dataset.error = 'true';
          message.textContent = labels.error;
        } finally {
          this.removeAttribute('aria-busy');
          const currentCheckout = drawer.querySelector('#CartDrawer-Checkout');
          if (currentCheckout && !drawer.classList.contains('is-empty')) currentCheckout.disabled = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kc-purchase-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kc-purchase-benefits')) {
    customElements.define('kc-purchase-benefits', class extends HTMLElement {
      connectedCallback() {
        const parts = new Intl.DateTimeFormat('en-CA', {timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(new Date());
        const part = type => Number(parts.find(item => item.type === type).value);
        const today = Date.UTC(part('year'), part('month') - 1, part('day'));
        const format = new Intl.DateTimeFormat('en-US', {weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC'});
        const dateLabel = this.querySelector('[data-kc-arrival]');
        if (dateLabel) dateLabel.textContent = format.format(new Date(today + 3 * 86400000)) + ' – ' + format.format(new Date(today + 5 * 86400000));
        const toggle = this.querySelector('.kc-offers-toggle');
        if (toggle && !toggle.dataset.bound) {
          toggle.dataset.bound = 'true';
          toggle.addEventListener('click', () => {
            const expanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', String(!expanded));
            this.querySelector('[data-offers-panel]').hidden = expanded;
          });
        }
        this.querySelectorAll('[data-kc-copy]').forEach(button => {
          if (button.dataset.bound) return;
          button.dataset.bound = 'true';
          button.addEventListener('click', async () => {
            const status = button.querySelector('[data-copy-status]');
            try {
              await navigator.clipboard.writeText(button.dataset.kcCopy);
              status.textContent = button.dataset.copiedLabel;
            } catch {
              status.textContent = button.dataset.failedLabel;
            }
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
